import { Link } from "react-router-dom";

function AIVideoAnalyzer() {
  return (
    <>
      <main className="contentarea">
        <section className="selectlang">
          <div className="container">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-12 mx-auto text-center">
                  <ul className="mb-0 languageList d-flex justify-content-center">
                    <li><Link to="/audio/UploadFile">Hindi</Link></li>
                    <li><Link to={undefined}>Kannada</Link></li>
                    <li><Link to={undefined}>Bengali</Link></li>
                    <li><Link to={undefined}>Marathi</Link></li>
                    <li><Link to={undefined}>Gujarati</Link></li>
                    <li><Link to={undefined}>Telugu</Link></li>
                    <li><Link to={undefined}>Tamil</Link></li>
                    <li><Link to={undefined}>Malayalam</Link></li>
                    <li><Link to={undefined}>Odia</Link></li>
                    <li><Link to={undefined}>Urdu</Link></li>
                    <li><Link to={undefined}>Punjabi</Link></li>
                    <li><Link to={undefined}>Assamese</Link></li>
                  </ul>
                  <button className="mt-4 button green">Proceed</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default AIVideoAnalyzer;
